import MxImageViewer from "./MxImageViewer";
import { getFileType } from "./utils/fileUtils";

interface FileViewerProps {
  url: string;
  height?: string;
  width?: string;
  type?: string | null | undefined;
}

const MxFileViewer: React.FC<FileViewerProps> = ({ url, height, width, type }) => {
  const fileType = getFileType(url, type);
  const isBlob = url.startsWith("blob:");
  const isExternal = url.startsWith("http") && !isBlob;

  switch (fileType) {
    case "image":
      return (
        <MxImageViewer
          src={url}
          variant="square"
          style={{
            width: width ?? "100%",
            height: height ?? "500px",
            borderRadius: "0px 0px 10px 10px"
          }}
        />
      );

    case "document":
      if (isBlob) {
        return (
          <embed
            src={url}
            type="application/pdf"
            width={width ?? "100%"}
            height={height ?? "500px"}
            style={{ border: "none" }}
          />
        );
      }
      return (
        <iframe
          src={`https://docs.google.com/viewer?url=${encodeURIComponent(
            url
          )}&embedded=true`}
          width={width ?? "100%"}
          height={height ?? "500px"}
          style={{ border: "none" }}
        />
      );

    case "spreadsheet":
      if (isBlob) {
        return (
          <embed
            src={url}
            type="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            width={width ?? "100%"}
            height={height ?? "500px"}
            style={{ border: "none" }}
          />
        );
      }
      return (
        <iframe
          src={`https://docs.google.com/viewer?url=${encodeURIComponent(
            url
          )}&embedded=true`}
          width={width ?? "100%"}
          height={height ?? "500px"}
          style={{ border: "none" }}
        />
      );

    case "presentation":
      if (isBlob) {
        return (
          <embed
            src={url}
            type="application/vnd.openxmlformats-officedocument.presentationml.presentation"
            width={width ?? "100%"}
            height={height ?? "500px"}
            style={{ border: "none" }}
          />
        );
      }
      return (
        <iframe
          src={`https://docs.google.com/viewer?url=${encodeURIComponent(
            url
          )}&embedded=true`}
          width={width ?? "100%"}
          height={height ?? "500px"}
          style={{ border: "none" }}
        />
      );
  
    default:
      return <div>Tipo de archivo no soportado</div>;
  }
};

export default MxFileViewer;
